/*
 * Symbol generator
 * ==========
 *
 * Generates symbol with appropriate probability.
 */

export
default class SymbolsGenerator {

  constructor () {
    this.sumFrequency = new Array(26);
    this.letterFrequency = [0.08167, 0.01492, 0.0278, 0.04253, 0.12702, 0.02288, 0.02022, 0.06094, 0.06973, 0.00153, 0.00747, 0.04025, 0.02517, 0.06749, 0.07507, 0.01929, 0.00098, 0.05987, 0.06333, 0.09056, 0.02758, 0.01037, 0.02465, 0.0015, 0.01971, 0.00074];
    this.alphabet = 'abcdefghijklmnopqrstuvwxyz';

    var frq = NaN;
    var frq1 = NaN;
    var i = 0;
    frq = 0;
    i = 0;

    while (i < 26) {
      frq = frq + this.letterFrequency[i];
      i++
    }

    frq1 = frq;
    frq = 0;
    i = 0;

    while (i < 26) {
      frq = frq + this.letterFrequency[i];
      this.sumFrequency[i] = frq / frq1;
      i++
    }
  }

  getRandomLetter (freq) {
    var index = 0;

    while (index < 26) {
      if (freq < this.sumFrequency[index]) {
        return this.alphabet.charAt(index)
      }

      index++
    }

    return 'e'
  }

}
